import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentStep: 1,
  formData: {
    applicantName: "",
    email: "",
    phone: "",
    education: "",
    yearsExperience: "",
    expertise: [],
    certifications: "",
    coverLetter: "",
    resume: null,
    notes: "",
    conflictOfInterest: {
      employeeOfFemaOrDhs: "NOT_ANSWERED",
      retiredEmployeeOfFemaOrDhs: "NOT_ANSWERED",
      currentEmployeeOrContractorOfFEMA_PTS: "NOT_ANSWERED",
      ptsJointVenture: "None",
      workLevel: "None",
      regions: [],
      states: [],
      localCommunityName: "",
      pastEmployeeOrContractor: "NOT_ANSWERED",
      nfipInvolvement: "NOT_ANSWERED",
      nfipWorkLevel: "None",
      nfipDetails: "",
    },
  },
  loading: false,
  error: null,
};

const applicationFormSlice = createSlice({
  name: "applicationForm",
  initialState,
  reducers: {
    setCurrentStep: (state, action) => {
      state.currentStep = action.payload;
    },
    updateFormData: (state, action) => {
      state.formData = { ...state.formData, ...action.payload };
    },
    updateConflictOfInterest: (state, action) => {
      state.formData.conflictOfInterest = {
        ...state.formData.conflictOfInterest,
        ...action.payload,
      };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    resetForm: (state) => {
      state.currentStep = 1;
      state.formData = initialState.formData;
      state.loading = false;
      state.error = null;
    },
    nextStep: (state) => {
      if (state.currentStep < 5) {
        state.currentStep += 1;
      }
    },
    prevStep: (state) => {
      if (state.currentStep > 1) {
        state.currentStep -= 1;
      }
    },
  },
});

export const {
  setCurrentStep,
  updateFormData,
  updateConflictOfInterest,
  setLoading,
  setError,
  resetForm,
  nextStep,
  prevStep,
} = applicationFormSlice.actions;

export default applicationFormSlice.reducer;
